import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../../helper/URLHelper';

const BrainAssistantsIndex = () => import('./BrainAssistantsIndex.vue');
const BrainAssistantPage = () => import('./BrainAssistantPage.vue');
const StepIdentity = () => import('./steps/StepIdentity.vue');
const StepScripts = () => import('./steps/StepScripts.vue');
const StepKnowledge = () => import('./steps/StepKnowledge.vue');
const StepSkills = () => import('./steps/StepSkills.vue');
const StepMessages = () => import('./steps/StepMessages.vue');
const StepModelRules = () => import('./steps/StepModelRules.vue');
const StepConnect = () => import('./steps/StepConnect.vue');
const InsightsPage = () => import('./InsightsPage.vue');
const CopilotPage = () => import('./CopilotPage.vue');

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.CAPTAIN_V2,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

export const brainRoutes = [
  {
    path: frontendURL('accounts/:accountId/captain/brain'),
    component: BrainAssistantsIndex,
    name: 'brain_assistants_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/brain/copilot'),
    component: CopilotPage,
    name: 'brain_copilot',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/brain/insights'),
    component: InsightsPage,
    name: 'brain_insights',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/captain/brain/:assistantId'),
    component: BrainAssistantPage,
    redirect: to => ({
      name: 'brain_wizard_identity',
      params: to.params,
    }),
    children: [
      {
        path: 'identity',
        component: StepIdentity,
        name: 'brain_wizard_identity',
        meta,
      },
      {
        path: 'scripts',
        component: StepScripts,
        name: 'brain_wizard_scripts',
        meta,
      },
      {
        path: 'knowledge',
        component: StepKnowledge,
        name: 'brain_wizard_knowledge',
        meta,
      },
      {
        path: 'skills',
        component: StepSkills,
        name: 'brain_wizard_skills',
        meta,
      },
      {
        path: 'messages',
        component: StepMessages,
        name: 'brain_wizard_messages',
        meta,
      },
      {
        path: 'model',
        component: StepModelRules,
        name: 'brain_wizard_model',
        meta,
      },
      {
        path: 'connect',
        component: StepConnect,
        name: 'brain_wizard_connect',
        meta,
      },
    ],
  },
];
